export const VIDEO_QUALITY = ['360P', '480P', '720P', '1080P']
export const DEFAULT_VIDEO_QUALITY = 2
export const DEFAULT_INTERVAL_TIME = 5 * 1000
